export default {
  task_list_1_desc: {
    en: "Sync your behavior data to Moon Ring APP daily and earn 100 MPT.",
    ja: "",
    ko: "",
    zh: "每天將您的行為數據同步到 MOON RING APP，賺取 100 MPT。",
    zh_cn: "每天将您的行为数据同步到 MOON RING APP，赚取 100 MPT。",
  },
  task_list_1_title: {
    en: "Daily Sync your Behavior data",
    ja: "",
    ko: "",
    zh: "每日同步行為數據",
    zh_cn: "每日同步行为数据",
  },
  task_list_2_desc: {
    en: "Earn 200 MPT daily by walking over 2,000 steps while wearing the Moon Ring.",
    ja: "",
    ko: "",
    zh: "佩戴 MOON RING 時，每天步行超過 2,000 步，即可獲得 200 MPT。",
    zh_cn: "佩戴 MOON RING 时，每天步行超过 2,000 步，即可获得 200 MPT。",
  },
  task_list_2_title: {
    en: "Daily steps exceed 2000",
    ja: "",
    ko: "",
    zh: "每日步數超過 2000 步",
    zh_cn: "每日步数超过 2000 步",
  },
  task_list_3_desc: {
    en: "Earn 100 MPT by checking your heart rate once daily.",
    ja: "",
    ko: "",
    zh: "每天檢測壹次心率，即可獲得 100 MPT。",
    zh_cn: "每天检测一次心率，即可获得 100 MPT。",
  },
  task_list_3_title: {
    en: "Manually check heart rate once daily",
    ja: "",
    ko: "",
    zh: "每天手動檢測壹次心率",
    zh_cn: "每天手动检测一次心率",
  },
  task_list_4_desc: {
    en: "Earn 150 MPT by burning 250 kcal daily.",
    ja: "",
    ko: "",
    zh: "每天消耗 250 千卡，可獲得 150 MPT。",
    zh_cn: "每天消耗 250 千卡，可获得 150 MPT。",
  },
  task_list_4_title: {
    en: "Burn 250 kcal daily",
    ja: "",
    ko: "",
    zh: "每天消耗 250 千卡",
    zh_cn: "每天消耗 250 千卡",
  },
  task_list_5_desc: {
    en: "Active and bind the Genesis identity; earn 150 MPT by wearing it daily and staying active.",
    ja: "",
    ko: "",
    zh: "活躍並綁定創世紀身份；每天佩戴並保持活躍，可獲得 150 MPT。",
    zh_cn: "活跃并绑定创世纪身份；每天佩戴并保持活跃，可获得 150 MPT。",
  },
  task_list_5_tips_content: {
    en: "To Unlock the Genesis Identity, you need to hold the Moon Ring Genesis NFT and complete the Genesis identity verification and binding on the Moon Ring official website.",
    ja: "",
    ko: "",
    zh: "解鎖創世身份，需要持有Moon Ring創世NFT，並在Moon Ring官網上完成創世身份驗證和綁定。",
    zh_cn:
      "解锁创世身份，需要持有Moon Ring创世NFT，并在Moon Ring官网上完成创世身份验证和绑定。",
  },
  task_list_5_tips_title: {
    en: "Before You Earn Your Moon Points",
    ja: "",
    ko: "",
    zh: "獲得Moon Points之前",
    zh_cn: "获得Moon Points之前",
  },
  task_list_5_title: {
    en: "Daily wear and active use of the Genesis series",
    ja: "",
    ko: "",
    zh: "創世紀系列的日常佩戴和有效使用",
    zh_cn: "创世纪系列的日常佩戴和有效使用",
  },
  task_list_6_desc: {
    en: "As long as you have a pioneer node NFT in the staking process, after completing four basic tasks, you will automatically receive a special reward of 1000MPT.",
    ja: "",
    ko: "",
    zh: "只要妳有質押中的先鋒節點NFT，完成四個基礎任務後，妳將自動獲取1000MPT的特殊獎勵",
    zh_cn:
      "只要你有质押中的先锋节点NFT，完成四个基础任务后，你将自动获取1000MPT的特殊奖励",
  },
  task_list_6_title: {
    en: "Special Bonus for Pioneer Node NFT Stakers",
    ja: "",
    ko: "",
    zh: "先鋒節點質押者特殊獎勵",
    zh_cn: "先锋节点质押者特殊奖励",
  },
  task_list_btn_claim: {
    en: "Claim",
    ja: "",
    ko: "",
    zh: "領取",
    zh_cn: "领取",
  },
  task_list_tips_btn_ok: {
    en: "OK",
    ja: "",
    ko: "",
    zh: "OK",
    zh_cn: "OK",
  },
  task_refresh_time: {
    en: "Refresh At ${a}(Local Time Zone)",
    ja: "",
    ko: "",
    zh: "刷新爲${a}(本地時區）",
    zh_cn: "刷新为${a}(本地时区）",
  },
  task_tips_text_error: {
    en: "Claim failed, please try again later!",
    ja: "",
    ko: "",
    zh: "領取失敗，請稍後再試！",
    zh_cn: "领取失败，请稍后再试！",
  },
  task_tips_text_success: {
    en: "Claim Success!",
    ja: "",
    ko: "",
    zh: "領取成功！",
    zh_cn: "领取成功！",
  },
  task_title_daily: {
    en: "DAILY TO THE MOON RING",
    ja: "",
    ko: "",
    zh: "MOON RING的日常",
    zh_cn: "MOON RING的日常",
  },
  task_title_today_mpt: {
    en: "Today MPT:",
    ja: "",
    ko: "",
    zh: "今日 MPT：",
    zh_cn: "今日 MPT：",
  },
  version: 1,
};
